import { useState, useEffect, useContext } from "react";
import undrawProfile from "../img/undraw_profile.svg";
import { AppContext } from "../contexts/AppContext";
import { AuthContext } from "../contexts/AuthContext";
import axiosHttp from "../config/axios.interceptor";
import { errorResponseMessage } from "../shared/const.prop";
import PostList from "../shared/PostList";
import { getActiveNotificationCount } from "../store/actions/notificationAction";
import { useDispatch } from "react-redux";
import { getActiveChatNotificationCount } from "../store/actions/chatNotificationAction";

const MyPosts = () => {
  const appContext = useContext(AppContext);
  const { user, logout } = useContext(AuthContext);
  const [postList, setPostList] = useState([]);
  const [loading, setLoading] = useState(true);
  const [page, setPage] = useState(1);
  // const [count, setCount] = useState(10);
  const [isOpenArray, setIsOpenArray] = useState();
  const [initialLoad, setInitialLoad] = useState(false);
  const [activeTab, setActiveTab] = useState("posts");
  const dispatch = useDispatch();

  // useEffect(() => {
  //   if (appContext.openModal === false) {
  //     fetchPosts(user);
  //   }
  // }, [page, count, user, appContext.openModal]);

  // useEffect(() => {
  //   if (isPromotion) {
  //     appContext.updateCategory("680c89f84f3447f6da04284f");
  //   } else {
  //     appContext.updateCategory("");
  //   }
  // }, [isPromotion]);

  useEffect(() => {
    if (appContext.openModal === false) {
      setLoading(true);
      fetchPosts(1);
      setInitialLoad(true);
    } else {
      fetchPosts(page);
      setInitialLoad(true);
    }
  }, [appContext.openModal, activeTab]);

  useEffect(() => {
    let debounceTimeout;

    const handleScroll = () => {
      clearTimeout(debounceTimeout);

      debounceTimeout = setTimeout(() => {
        const scrollY = window.scrollY;
        const viewportHeight = window.innerHeight;
        const pageHeight = document.documentElement.scrollHeight;

        const scrollThreshold = 0.8;

        const distanceFromBottom = pageHeight - (scrollY + viewportHeight);

        if (
          distanceFromBottom / pageHeight <= 1 - scrollThreshold &&
          !loading &&
          initialLoad
        ) {
          fetchPosts(page);
        }
      }, 200);
    };

    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, [page, loading, initialLoad]);

  useEffect(() => {
    dispatch(getActiveNotificationCount());
    dispatch(getActiveChatNotificationCount());
  }, []);

  const fetchPosts = async (page, isDelete = false) => {
    // setLoading(true);
    try {
      // let userId = user?.userId || user?.data?.data?.userId;
      // if (userId) {
      const getPostsList = await axiosHttp.get(
        // `post-data?page=${page}&type=post`
        activeTab === "promotions"
          ? `post-data?page=${page}&skillCategoryId=680c89f84f3447f6da04284f`
          : appContext.category === ""
          ? `post-data?page=${page}`
          : `post-data?page=${page}&skillCategoryId=${appContext.category}`
      );
      if (getPostsList.status === 200) {
        let data = getPostsList?.data?.data;
        if (page === 1) {
          setPostList(data);
        } else {
          setPostList([...postList, ...data]);
        }
        if (isDelete) {
          setPage(2);
        } else {
          setPage(page + 1);
        }
        setIsOpenArray(data.map(() => false));
        setLoading(false);
      }
      // }
    } catch (e) {
      if (e.response.status === 429) {
        appContext.updateNotificationState({
          show: true,
          message: errorResponseMessage(e),
          type: "error",
        });
        logout();
      }
      if (e.response.status === 400) {
        appContext.updateNotificationState({
          show: true,
          message: errorResponseMessage(e),
          type: "error",
        });
      }
      // appContext.updateNotificationState({
      //   show: true,
      //   message: errorResponseMessage(e),
      //   type: "error",
      // });
      //console.log(e);
      if (e.response.status === 422 && page === 1) {
        setPostList([]);
        setLoading(false);
      }
      if (e.response.status >= 500) {
        appContext.updateNotificationState({
          show: true,
          message: "Something went wrong, please try again later.",
          type: "error",
        });
      }
      setLoading(false);
      setInitialLoad(false);
    }
  };

  const likePostHandler = async (id) => {
    try {
      const likePostResponse = await axiosHttp.post(`post/${id}/like`);
      if (likePostResponse.status === 201) {
        const updatedPostList = postList.map((post) => {
          if (post.id === id) {
            return {
              ...post,
              likeStatus: post.likeStatus === "Like" ? "DisLike" : "Like",
              postLikeCount:
                post.likeStatus === "Like"
                  ? post.postLikeCount - 1
                  : post.postLikeCount + 1,
            };
          }
          return post;
        });

        setPostList(updatedPostList);
      }
    } catch (error) {
      if (error.response.status === 429) {
        appContext.updateNotificationState({
          show: true,
          message: errorResponseMessage(error),
          type: "error",
        });
        logout();
      }
      if (error.response.status === 400) {
        appContext.updateNotificationState({
          show: true,
          message: errorResponseMessage(error),
          type: "error",
        });
      }
      if (error.response.status >= 500) {
        appContext.updateNotificationState({
          show: true,
          message: "Something went wrong, please try again later.",
          type: "error",
        });
      }
    }
    //console.log(error);
  };

  const bookHandler = async (id) => {
    try {
      const bookPostResponse = await axiosHttp.post(`post/${id}/bookmark`);
      if (bookPostResponse.status === 201) {
        const updatedPostList = postList.map((post) => {
          if (post.id === id) {
            return {
              ...post,
              isBookmark:
                post.isBookmark === "Not" || post.isBookmark === "No"
                  ? "Yes"
                  : "Not",
            };
          }
          return post;
        });

        setPostList(updatedPostList);
      }
    } catch (error) {
      if (error.response.status === 429) {
        appContext.updateNotificationState({
          show: true,
          message: errorResponseMessage(error),
          type: "error",
        });
        logout();
      }
      if (error.response.status === 400) {
        appContext.updateNotificationState({
          show: true,
          message: errorResponseMessage(error),
          type: "error",
        });
      }
      if (error.response.status >= 500) {
        appContext.updateNotificationState({
          show: true,
          message: "Something went wrong, please try again later.",
          type: "error",
        });
      }
    }
  };

  const toggleDiv = (index) => {
    const newIsOpenArray = [...isOpenArray];
    newIsOpenArray[index] = !newIsOpenArray[index];
    setIsOpenArray(newIsOpenArray);
  };

  const editHandler = (post) => {
    const { type } = post;
    if (type === "image") {
      appContext.updateModalType("postPhoto", "Edit your photo", post);
    } else if (type === "doc") {
      appContext.updateModalType("postDocument", "Edit Document", post);
    } else if (type === "video") {
      appContext.updateModalType("postVideo", "Edit your video", post);
    } else if (type === "reels") {
      appContext.updateModalType("addReels", "Edit Reels", post);
    } else {
      appContext.updateModalType("postText", "Edit Text", post);
    }
  };

  const deleteHandler = async (post) => {
    try {
      const deletePost = await axiosHttp.delete(`post-data/${post.id}`);
      if (deletePost.status === 200) {
        setLoading(true);
        let isDelete = true;
        setPostList([]);
        fetchPosts(1, isDelete);
      }
    } catch (e) {
      if (e.response.status === 429) {
        appContext.updateNotificationState({
          show: true,
          message: errorResponseMessage(e),
          type: "error",
        });
        logout();
      }
      if (e.response.status === 400) {
        appContext.updateNotificationState({
          show: true,
          message: errorResponseMessage(e),
          type: "error",
        });
      }
      if (e.response.status >= 500) {
        appContext.updateNotificationState({
          show: true,
          message: "Something went wrong, please try again later.",
          type: "error",
        });
      }
      //console.log(e);
      setLoading(false);
    }
  };

  const retweetHandler = async (id) => {
    try {
      const retweetPost = await axiosHttp.post(`/post/${id}/share`);
      if (retweetPost.status === 201) {
        setLoading(true);
        let isDelete = true;
        setPostList([]);
        appContext.updateNotificationState({
          show: true,
          message: "Repost successful",
          type: "success",
        });
        window.scrollTo(0, 0);
        fetchPosts(1, isDelete);
      }
    } catch (e) {
      if (e.response.status === 429) {
        appContext.updateNotificationState({
          show: true,
          message: errorResponseMessage(e),
          type: "error",
        });
        logout();
      }
      if (e.response.status === 400) {
        appContext.updateNotificationState({
          show: true,
          message: errorResponseMessage(e),
          type: "error",
        });
      }
      if (e.response.status >= 500) {
        appContext.updateNotificationState({
          show: true,
          message: "Something went wrong, please try again later.",
          type: "error",
        });
      }
      //console.log(e);
      setLoading(false);
    }
  };

  return (
    <>
      <div className="card card-one-1 mb-2">
        <div className="card-body">
          <nav className="mb-2">
            <div className="nav nav-tabs no-wrap" id="nav-tab" role="tablist">
              <button
                className={
                  activeTab === "posts"
                    ? "nav-item nav-link active w-100"
                    : "btn nav-item nav-link w-100"
                }
                onClick={() => {
                  appContext.updateCategory("");
                  setActiveTab("posts");
                }}
              >
                Posts
              </button>
              <button
                className={
                  activeTab === "promotions"
                    ? "nav-item nav-link active w-100"
                    : "btn nav-item nav-link w-100"
                }
                onClick={() => {
                  appContext.updateCategory("680c89f84f3447f6da04284f");
                  setActiveTab("promotions");
                }}
              >
                Promotions
              </button>
            </div>
          </nav>
        </div>
      </div>
      <PostList
        loading={loading}
        postList={postList}
        likePostHandler={likePostHandler}
        // isEdit={true}
        expertiesKey="name"
        toggleDiv={toggleDiv}
        isOpenArray={isOpenArray}
        editHandler={editHandler}
        deleteHandler={deleteHandler}
        bookHandler={bookHandler}
        retweetHandler={retweetHandler}
      />
    </>
  );
};

export default MyPosts;
